import { motion } from 'motion/react';

import { useI18n } from '../../i18n';

export default function HeroSection() {
  const { t } = useI18n();

  return (
    <section
      id="hero"
      className="relative mt-36 px-4 py-12 text-center sm:px-6 sm:py-16 md:px-8 md:py-20 lg:px-32"
    >
      <div className="pointer-events-none absolute top-0 left-0 h-full w-full overflow-hidden">
        <motion.div
          className="absolute top-[-150px] right-[-100px] h-[400px] w-[400px] sm:top-[-200px] sm:right-[-50px] sm:h-[600px] sm:w-[600px] md:top-[-270px] md:right-[50px] md:h-[800px] md:w-[800px] lg:right-[137px] lg:h-[1141px] lg:w-[1166px]"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.2, ease: 'easeOut' }}
        >
          <img
            src="/images/hero-pattern.svg"
            alt=""
            className="h-full w-full object-contain"
          />
        </motion.div>
      </div>

      <div className="relative z-10 mx-auto max-w-xs sm:max-w-lg md:max-w-2xl lg:max-w-4xl">
        <p className="mb-2 px-2 text-2xl leading-tight font-bold text-[#00a63e] sm:mb-3 sm:text-3xl md:text-4xl lg:text-5xl">
          {t.hero.brandName}
        </p>
        <h1 className="mb-4 px-2 text-xl leading-tight font-bold text-gray-900 sm:mb-6 sm:text-2xl md:text-3xl lg:text-4xl">
          {t.hero.title}
        </h1>
        <p className="mx-auto mb-6 max-w-full px-2 text-base leading-relaxed text-gray-900 sm:mb-8 sm:max-w-2xl sm:text-lg md:max-w-4xl md:text-xl lg:max-w-5xl lg:text-2xl">
          {t.hero.description}
        </p>
        <div className="flex flex-row justify-center gap-3 sm:gap-4">
          <motion.a
            href="https://customer.medhub.tgl.com.sa"
            target="_blank"
            rel="noopener"
            className="inline-flex w-full max-w-xs items-center justify-center rounded-md bg-[#00a63e] px-6 py-2.5 text-sm font-bold text-white transition-colors hover:bg-green-700 sm:w-auto sm:px-12 sm:py-3 sm:text-base md:px-16 lg:px-18"
            whileHover={{
              scale: 1.05,
              backgroundColor: '#007a30',
              boxShadow: '0 10px 25px rgba(0, 166, 62, 0.3)',
            }}
            whileTap={{ scale: 0.95 }}
          >
            {t.hero.registerAsCustomer}
          </motion.a>
          <motion.a
            href="https://provider.medhub.tgl.com.sa"
            target="_blank"
            rel="noopener"
            className="inline-flex w-full max-w-xs items-center justify-center rounded-md border-2 border-[#00a63e] bg-white px-6 py-2.5 text-sm font-bold text-[#00a63e] transition-colors hover:bg-gray-50 sm:w-auto sm:px-12 sm:py-3 sm:text-base md:px-16 lg:px-18"
            whileHover={{
              scale: 1.05,
              boxShadow: '0 10px 25px rgba(0, 166, 62, 0.2)',
            }}
            whileTap={{ scale: 0.95 }}
          >
            {t.hero.joinAsVendor}
          </motion.a>
        </div>
      </div>
    </section>
  );
}
